import React from "react";
import SuperUserForm from "../../componentsGeneral/componentsSuperUser/superUserForm/SuperUserForm";

const FormUser = () => {
  return (
    <div>
      <SuperUserForm />
    </div>
  );
};

export default FormUser;
